/*
Monotype Foundry Platform API
Version 1.0.0

Definition: CreatePresignedUrlRequest

Properties:
  keys: array
*/

var CreatePresignedUrlRequest = (function () {
  function validateCreatePresignedUrlRequest (arg) {
    // Validate keys
    if (arg.keys && !(Array.isArray(arg.keys))) {
      throw new Error('CreatePresignedUrlRequest.keys: Wrong type: Got \'' + (typeof arg.keys) + '\', but expected: \'array\'')
    }
  }
  function buildCreatePresignedUrlRequest (arg) {
    var CreatePresignedUrlRequest = arg
    // Complete keys
    // Expected Type: array
    CreatePresignedUrlRequest.keys = CreatePresignedUrlRequest.keys || []
    return CreatePresignedUrlRequest
  }
  return {
    validate: validateCreatePresignedUrlRequest,
    build: buildCreatePresignedUrlRequest
  }
})()

module.exports = CreatePresignedUrlRequest
